<template>
  <div class="w-[28px] h-[28px] rounded-full bg-unify-grey-100 flex items-center justify-center border-unify-grey-50 border-2">
    <slot name="icon" />
  </div>
</template>
<script setup lang="ts">
</script>